import { CommonDictType } from "common/types";

/**
 * 公司类型，用户登录后返回，可能有多家公司
 */
export interface CompanyType {
  /** 公司cid */
  companyId: string;
  /** 公司名称 */
  name: string;
  /** 公司logo */
  companyLogo: string;
  /** 公司超管id */
  userId: string;
}

/**
 * 当前用户信息
 */
export interface UserInfoType {
  /** 用户Id */
  userId: string;
  /** 用户姓名 */
  realName: string;
  /** 头像 */
  picture: string;
  /** 性别 */
  gender: string;
  /** 邮箱 */
  email: string;
  /** 邮箱是否激活 */
  emailActive: boolean;
  /** 手机 */
  mobile: string;
  /** 手机是否激活 */
  mobileActive: boolean;
  /** 公司cid */
  cid: string;
  /** 公司名称 */
  companyName: string;
  /** 公司Logo */
  companyLogo: string;
  /** 超管id */
  superUserId: string;
}

/**登录信息 */
export interface LoginData {
  appId: string;
  certStatus: string;
  companyList: [];
  deviceNo: any;
  email: string;
  emailActive: any;
  gender: string;
  kicked: boolean;
  lastLogin: string;
  loginAccount: string;
  loginIp: string;
  mobile: string;
  mobileActive: boolean;
  nickName: string;
  picture: string;
  realName: string;
  seconds: number;
  sourceCid: string;
  sourceFlag: string;
  statusFlag: string;
  ticket: string;
  token: string;
  userId: string;
}

export interface AuthState {
  /** 用户信息 */
  readonly userInfo: UserInfoType;
  /**字典 */
  readonly commonMap: CommonDictType;
  /**登录信息 */
  readonly loginData: LoginData;
  /**注册成功的信息 */
  readonly registerData: any;
}

export enum AuthActionTypes {
  /** 登录 */
  FETCH_LOGIN = "登录/FETCH_LOGIN",
  /** 存储用户信息 */
  FETCH_STORE_USERINFO = "存储用户信息/FETCH_STORE_USERINFO",
  /** 更新Auth状态 */
  FETCH_UPDATE_AUTH_STATE = "更新Auth状态/FETCH_UPDATE_AUTH_STATE",
}